module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "endorsements"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagei",
      "title": "i"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pageii",
      "title": "ii"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pageiii",
      "title": "iii"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pageiv",
      "title": "iv"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagev",
      "title": "v"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tp3"
  }, [_vm._v("Reformation Commentary on Scripture")]), _vm._v(" "), _c('p', {
    staticClass: "tp3"
  }, [_vm._v("Old Testament V")]), _vm._v(" "), _c('p', {
    staticClass: "tp2"
  }, [_vm._v("1–2 Samuel, 1–2 Kings, 1–2 Chronicles")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }), _vm._v(" "), _c('p', {
    staticClass: "tp4"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tp4"
  }, [_vm._v("Edited by"), _c('br'), _vm._v("\n    Derek Cooper and Martin J. Lohrmann")]), _vm._v(" "), _c('p', {
    staticClass: "tp4"
  }, [_vm._v("General Editor"), _c('br'), _vm._v("\n    Timothy George")]), _vm._v(" "), _c('p', {
    staticClass: "tp4"
  }, [_vm._v("Associate General Editor"), _c('br'), _vm._v("\n    Scott M. Manetsch")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "http://www.IVPress.com/academic",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "IVP Academic Imprint",
      "src": "Images/IVPAcademic.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagevi",
      "title": "vi"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ceaacd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/titlepage.vue
// module id = 57
// module chunks = 0